// extracted by mini-css-extract-plugin
module.exports = {"header":"_2N0_k","title":"_3kJS7","cancel":"_1wEHt"};